/* RESPONSIBLE TEAM: team-inbox-management */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-classic-classes */
import Model, { attr } from '@ember-data/model';
import { computed } from '@ember/object';

const DEFAULT_BACKGROUND = 'background-1';

export default Model.extend({
  admin_messenger_background: attr('string'),
  away_mode_reassign_team_id: attr('string'),
  favoriteReports: attr('array'),
  translation_enabled: attr('boolean'),
  excluded_languages: attr('string'),
  preferred_locale: attr('string'),
  default_outbound_phone_number_id: attr('string'),
  undo_send_delay_seconds: attr('number'),
  excludedLanguagesArray: computed('excluded_languages', {
    get() {
      return this.excluded_languages ? this.excluded_languages.split(',') : [];
    },
    set(key, value) {
      this.set('excluded_languages', value.join(','));
      return value;
    },
  }),
  adminMessengerBackground: computed('admin_messenger_background', {
    get() {
      return this.admin_messenger_background || DEFAULT_BACKGROUND;
    },
    set(key, value) {
      this.set('admin_messenger_background', value);
      return value || DEFAULT_BACKGROUND;
    },
  }),
});
